module.exports = __webpack_public_path__ + "img/grg_universidades.01b31429.svg";